export default __webpack_public_path__ + "static/fall35-45bf6b3e914c0fc9e7a108ec6d2a9c3d.webp";